import * as React from "react"
import { Dimmer, Loader } from "semantic-ui-react"

interface Props {
  isLoading: boolean
  label?: string
}

const Spinner = ({ isLoading, label = "" }: Props) => {
  return (
    <Dimmer active={isLoading} inverted>
      <Loader size="small">{label}</Loader>
    </Dimmer>
  )
}

export default Spinner
